import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'leadingZero',
  standalone: true
})
export class LeadingZeroPipe implements PipeTransform {
  transform(value: number | undefined | null, padWidth = 8): string {
    const str = value?.toString() ?? '';
    return str ? str.padWithLeadingZeros(padWidth) : str;
  }
}
